module.exports = __webpack_public_path__ + "img/aboutUsImg05.9bd4b29f.png";